define("shared/components/shared/profile-categorization/rewards-steps/tab/engagement-distribution", ["exports", "@ember/component", "@ember/service", "@ember/template", "@ember/utils", "@glimmer/component", "later/utils/number-helpers", "@ember/template-factory"], function (_exports, _component, _service, _template, _utils, _component2, _numberHelpers, _templateFactory) {
  "use strict";

  Object.defineProperty(_exports, "__esModule", {
    value: true
  });
  _exports.default = void 0;
  var _class, _descriptor;
  0; //eaimeta@70e063a35619d71f0,"ember-cli-htmlbars",0,"@ember/service",0,"@ember/template",0,"@ember/utils",0,"@glimmer/component",0,"later/utils/number-helpers",0,"@ember/component"eaimeta@70e063a35619d71f
  function _initializerDefineProperty(e, i, r, l) { r && Object.defineProperty(e, i, { enumerable: r.enumerable, configurable: r.configurable, writable: r.writable, value: r.initializer ? r.initializer.call(l) : void 0 }); }
  function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
  function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == typeof i ? i : i + ""; }
  function _toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
  function _applyDecoratedDescriptor(i, e, r, n, l) { var a = {}; return Object.keys(n).forEach(function (i) { a[i] = n[i]; }), a.enumerable = !!a.enumerable, a.configurable = !!a.configurable, ("value" in a || a.initializer) && (a.writable = !0), a = r.slice().reverse().reduce(function (r, n) { return n(i, e, r) || r; }, a), l && void 0 !== a.initializer && (a.value = a.initializer ? a.initializer.call(l) : void 0, a.initializer = void 0), void 0 === a.initializer ? (Object.defineProperty(i, e, a), null) : a; }
  function _initializerWarningHelper(r, e) { throw Error("Decorating class property failed. Please ensure that transform-class-properties is enabled and runs after the decorators transform."); }
  const __COLOCATED_TEMPLATE__ = (0, _templateFactory.createTemplateFactory)(
  /*
    <div class="tOB--chartContainer u--fadeIn" {{did-insert @triggerSegmentEvent}}>
    {{#let (concat "profile_categorization.reports." @sectionName ".engagement_distribution.") as |prefix|}}
  
      <h4 class="u--text--md u--m__tb">
        {{t (concat prefix "title")}}
        {{svg-jar "help" class="o--icon--sm"}}
        <EmberTooltip @event="hover">
          {{t (concat prefix "title_tooltip")}}
        </EmberTooltip>
      </h4>
  
      {{#if this.isAboveMax}}
  
        <div class="tOB--barGraph qa--categorize_reports_tab_1_content">
          <div
            class="tOB--barGraph__highlight"
            style="left:{{this.industryLimitsPositions.left}}%; right:{{this.industryLimitsPositions.right}}%; "
          ></div>
          <div class="tOB--barGraph__values">
            <span class="tOB--barGraph__value--avgStart" style="left:{{this.industryLimitsPositions.left}}%;">
              {{if (lt @limits.min 0) 0 @limits.min}}%
              {{svg-jar "help" class="o--icon--sm"}}
              <EmberTooltip @event="hover">
                <span>
                  {{t "profile_categorization.reports.shared.low_end"}}
                </span>
              </EmberTooltip>
            </span>
            <span class="tOB--barGraph__value--end">
              {{@limits.max}}%
              {{svg-jar "help" class="o--icon--sm"}}
              <EmberTooltip @event="hover">
                <span>
                  {{t "profile_categorization.reports.shared.high_end"}}
                </span>
              </EmberTooltip>
            </span>
            <span class="tOB--barGraph__value--end">{{this.topPercentRounded}}%</span>
          </div>
  
          <div class="tOB--barGraph__markers">
            <div class="tOB--barGraph__marker" style="left:{{this.industryMarkerPostion}}%;">
              <img class="o--media" src="assets/images/tOB--image__industry.png" />
              <span class="tOB--barGraph__tooltip tOB--barGraph__tooltip--bottom">
                {{t (concat prefix "industry_average")}}
                ({{@industryEngagement}}%)
              </span>
            </div>
  
            <div
              class="tOB--barGraph__marker
                {{if this.isAboveAverage 'tOB--barGraph__marker--above' 'tOB--barGraph__marker--below'}}"
              style="left:{{this.profileMarkerPostion}}%;"
            >
              <img class="o--media" src={{@socialProfile.avatarUrl}} />
              <span class="tOB--barGraph__tooltip tOB--barGraph__tooltip--top">
                {{t
                  "profile_categorization.reports.shared.profile_engagement"
                  engagement=@profileEngagement
                  nickname=@socialProfile.nickname
                }}
              </span>
            </div>
          </div>
        </div>
  
      {{else}}
  
        <div class="tOB--barGraph qa--categorize_reports_tab_1_content">
          <div
            class="tOB--barGraph__highlight"
            style="left:{{this.industryLimitsPositions.left}}%; right:{{this.industryLimitsPositions.right}}%;"
          ></div>
          <div class="tOB--barGraph__values">
            {{#if this.isBelowMin}}
              <span class="tOB--barGraph__value--start">
                {{t "profile_categorization.reports.shared.zero"}}
              </span>
              <span class="tOB--barGraph__value--avgStart" style="left:{{this.industryLimitsPositions.left}}%;">
                {{if (lt @limits.min 0) 0 @limits.min}}%
                {{svg-jar "help" class="o--icon--sm"}}
                <EmberTooltip @event="hover">
                  <span>
                    {{t "profile_categorization.reports.shared.low_end"}}
                  </span>
                </EmberTooltip>
              </span>
              <span class="tOB--barGraph__value--end">
                {{@limits.max}}%
                {{svg-jar "help" class="o--icon--sm"}}
                <EmberTooltip @event="hover">
                  <span>
                    {{t "profile_categorization.reports.shared.high_end"}}
                  </span>
                </EmberTooltip>
              </span>
            {{else}}
              <span class="tOB--barGraph__value--avgStart">
                {{if (lt @limits.min 0) 0 @limits.min}}%
                {{svg-jar "help" class="o--icon--sm"}}
                <EmberTooltip @event="hover">
                  <span>
                    {{t "profile_categorization.reports.shared.low_end"}}
                  </span>
                </EmberTooltip>
              </span>
              <span class="tOB--barGraph__value--end">
                {{@limits.max}}%
                {{svg-jar "help" class="o--icon--sm"}}
                <EmberTooltip @event="hover">
                  <span>
                    {{t "profile_categorization.reports.shared.high_end"}}
                  </span>
                </EmberTooltip>
              </span>
            {{/if}}
          </div>
  
          <div class="tOB--barGraph__markers">
            <div class="tOB--barGraph__marker" style="left:{{this.industryMarkerPostion}}%;">
              <img class="o--media" src="assets/images/tOB--image__industry.png" />
              <span class="tOB--barGraph__tooltip tOB--barGraph__tooltip--bottom">
                {{t (concat prefix "industry_average")}}
                ({{@industryEngagement}}%)
              </span>
            </div>
  
            <div
              class="tOB--barGraph__marker
                {{if this.isAboveAverage 'tOB--barGraph__marker--above' 'tOB--barGraph__marker--below'}}"
              style="left:{{this.profileMarkerPostion}}%;"
            >
              <img class="o--media" src={{@socialProfile.avatarUrl}} />
              <span class="tOB--barGraph__tooltip tOB--barGraph__tooltip--top">
                {{t
                  "profile_categorization.reports.shared.profile_engagement"
                  engagement=@profileEngagement
                  nickname=@socialProfile.nickname
                }}
              </span>
            </div>
          </div>
        </div>
  
      {{/if}}
  
      <h4 class="u--text--md u--m__tb">
        {{t (concat prefix "engagement_summary")}}
      </h4>
  
      <div class="u--m__tb">{{this.rewardText}}</div>
  
      <span class="u--text--bold">{{t (concat prefix "tips")}}</span>
  
      {{html-safe (t (concat prefix (if this.isAboveAverage "success_links_html" "failure_links_html")))}}
  
      <p class="u--text--sm u--text--light u--m__b__0">{{t "profile_categorization.reports.disclaimer"}}</p>
  
    {{/let}}
  </div>
  */
  {
    "id": "qwaprIcP",
    "block": "[[[11,0],[24,0,\"tOB--chartContainer u--fadeIn\"],[4,[38,0],[[30,1]],null],[12],[1,\"\\n\"],[44,[[28,[37,2],[\"profile_categorization.reports.\",[30,2],\".engagement_distribution.\"],null]],[[[1,\"\\n    \"],[10,\"h4\"],[14,0,\"u--text--md u--m__tb\"],[12],[1,\"\\n      \"],[1,[28,[35,3],[[28,[37,2],[[30,3],\"title\"],null]],null]],[1,\"\\n      \"],[1,[28,[35,4],[\"help\"],[[\"class\"],[\"o--icon--sm\"]]]],[1,\"\\n      \"],[8,[39,5],null,[[\"@event\"],[\"hover\"]],[[\"default\"],[[[[1,\"\\n        \"],[1,[28,[35,3],[[28,[37,2],[[30,3],\"title_tooltip\"],null]],null]],[1,\"\\n      \"]],[]]]]],[1,\"\\n    \"],[13],[1,\"\\n\\n\"],[41,[30,0,[\"isAboveMax\"]],[[[1,\"\\n      \"],[10,0],[14,0,\"tOB--barGraph qa--categorize_reports_tab_1_content\"],[12],[1,\"\\n        \"],[10,0],[14,0,\"tOB--barGraph__highlight\"],[15,5,[29,[\"left:\",[30,0,[\"industryLimitsPositions\",\"left\"]],\"%; right:\",[30,0,[\"industryLimitsPositions\",\"right\"]],\"%; \"]]],[12],[13],[1,\"\\n        \"],[10,0],[14,0,\"tOB--barGraph__values\"],[12],[1,\"\\n          \"],[10,1],[14,0,\"tOB--barGraph__value--avgStart\"],[15,5,[29,[\"left:\",[30,0,[\"industryLimitsPositions\",\"left\"]],\"%;\"]]],[12],[1,\"\\n            \"],[1,[52,[28,[37,7],[[30,4,[\"min\"]],0],null],0,[30,4,[\"min\"]]]],[1,\"%\\n            \"],[1,[28,[35,4],[\"help\"],[[\"class\"],[\"o--icon--sm\"]]]],[1,\"\\n            \"],[8,[39,5],null,[[\"@event\"],[\"hover\"]],[[\"default\"],[[[[1,\"\\n              \"],[10,1],[12],[1,\"\\n                \"],[1,[28,[35,3],[\"profile_categorization.reports.shared.low_end\"],null]],[1,\"\\n              \"],[13],[1,\"\\n            \"]],[]]]]],[1,\"\\n          \"],[13],[1,\"\\n          \"],[10,1],[14,0,\"tOB--barGraph__value--end\"],[12],[1,\"\\n            \"],[1,[30,4,[\"max\"]]],[1,\"%\\n            \"],[1,[28,[35,4],[\"help\"],[[\"class\"],[\"o--icon--sm\"]]]],[1,\"\\n            \"],[8,[39,5],null,[[\"@event\"],[\"hover\"]],[[\"default\"],[[[[1,\"\\n              \"],[10,1],[12],[1,\"\\n                \"],[1,[28,[35,3],[\"profile_categorization.reports.shared.high_end\"],null]],[1,\"\\n              \"],[13],[1,\"\\n            \"]],[]]]]],[1,\"\\n          \"],[13],[1,\"\\n          \"],[10,1],[14,0,\"tOB--barGraph__value--end\"],[12],[1,[30,0,[\"topPercentRounded\"]]],[1,\"%\"],[13],[1,\"\\n        \"],[13],[1,\"\\n\\n        \"],[10,0],[14,0,\"tOB--barGraph__markers\"],[12],[1,\"\\n          \"],[10,0],[14,0,\"tOB--barGraph__marker\"],[15,5,[29,[\"left:\",[30,0,[\"industryMarkerPostion\"]],\"%;\"]]],[12],[1,\"\\n            \"],[10,\"img\"],[14,0,\"o--media\"],[14,\"src\",\"assets/images/tOB--image__industry.png\"],[12],[13],[1,\"\\n            \"],[10,1],[14,0,\"tOB--barGraph__tooltip tOB--barGraph__tooltip--bottom\"],[12],[1,\"\\n              \"],[1,[28,[35,3],[[28,[37,2],[[30,3],\"industry_average\"],null]],null]],[1,\"\\n              (\"],[1,[30,5]],[1,\"%)\\n            \"],[13],[1,\"\\n          \"],[13],[1,\"\\n\\n          \"],[10,0],[15,0,[29,[\"tOB--barGraph__marker\\n              \",[52,[30,0,[\"isAboveAverage\"]],\"tOB--barGraph__marker--above\",\"tOB--barGraph__marker--below\"]]]],[15,5,[29,[\"left:\",[30,0,[\"profileMarkerPostion\"]],\"%;\"]]],[12],[1,\"\\n            \"],[10,\"img\"],[14,0,\"o--media\"],[15,\"src\",[30,6,[\"avatarUrl\"]]],[12],[13],[1,\"\\n            \"],[10,1],[14,0,\"tOB--barGraph__tooltip tOB--barGraph__tooltip--top\"],[12],[1,\"\\n              \"],[1,[28,[35,3],[\"profile_categorization.reports.shared.profile_engagement\"],[[\"engagement\",\"nickname\"],[[30,7],[30,6,[\"nickname\"]]]]]],[1,\"\\n            \"],[13],[1,\"\\n          \"],[13],[1,\"\\n        \"],[13],[1,\"\\n      \"],[13],[1,\"\\n\\n\"]],[]],[[[1,\"\\n      \"],[10,0],[14,0,\"tOB--barGraph qa--categorize_reports_tab_1_content\"],[12],[1,\"\\n        \"],[10,0],[14,0,\"tOB--barGraph__highlight\"],[15,5,[29,[\"left:\",[30,0,[\"industryLimitsPositions\",\"left\"]],\"%; right:\",[30,0,[\"industryLimitsPositions\",\"right\"]],\"%;\"]]],[12],[13],[1,\"\\n        \"],[10,0],[14,0,\"tOB--barGraph__values\"],[12],[1,\"\\n\"],[41,[30,0,[\"isBelowMin\"]],[[[1,\"            \"],[10,1],[14,0,\"tOB--barGraph__value--start\"],[12],[1,\"\\n              \"],[1,[28,[35,3],[\"profile_categorization.reports.shared.zero\"],null]],[1,\"\\n            \"],[13],[1,\"\\n            \"],[10,1],[14,0,\"tOB--barGraph__value--avgStart\"],[15,5,[29,[\"left:\",[30,0,[\"industryLimitsPositions\",\"left\"]],\"%;\"]]],[12],[1,\"\\n              \"],[1,[52,[28,[37,7],[[30,4,[\"min\"]],0],null],0,[30,4,[\"min\"]]]],[1,\"%\\n              \"],[1,[28,[35,4],[\"help\"],[[\"class\"],[\"o--icon--sm\"]]]],[1,\"\\n              \"],[8,[39,5],null,[[\"@event\"],[\"hover\"]],[[\"default\"],[[[[1,\"\\n                \"],[10,1],[12],[1,\"\\n                  \"],[1,[28,[35,3],[\"profile_categorization.reports.shared.low_end\"],null]],[1,\"\\n                \"],[13],[1,\"\\n              \"]],[]]]]],[1,\"\\n            \"],[13],[1,\"\\n            \"],[10,1],[14,0,\"tOB--barGraph__value--end\"],[12],[1,\"\\n              \"],[1,[30,4,[\"max\"]]],[1,\"%\\n              \"],[1,[28,[35,4],[\"help\"],[[\"class\"],[\"o--icon--sm\"]]]],[1,\"\\n              \"],[8,[39,5],null,[[\"@event\"],[\"hover\"]],[[\"default\"],[[[[1,\"\\n                \"],[10,1],[12],[1,\"\\n                  \"],[1,[28,[35,3],[\"profile_categorization.reports.shared.high_end\"],null]],[1,\"\\n                \"],[13],[1,\"\\n              \"]],[]]]]],[1,\"\\n            \"],[13],[1,\"\\n\"]],[]],[[[1,\"            \"],[10,1],[14,0,\"tOB--barGraph__value--avgStart\"],[12],[1,\"\\n              \"],[1,[52,[28,[37,7],[[30,4,[\"min\"]],0],null],0,[30,4,[\"min\"]]]],[1,\"%\\n              \"],[1,[28,[35,4],[\"help\"],[[\"class\"],[\"o--icon--sm\"]]]],[1,\"\\n              \"],[8,[39,5],null,[[\"@event\"],[\"hover\"]],[[\"default\"],[[[[1,\"\\n                \"],[10,1],[12],[1,\"\\n                  \"],[1,[28,[35,3],[\"profile_categorization.reports.shared.low_end\"],null]],[1,\"\\n                \"],[13],[1,\"\\n              \"]],[]]]]],[1,\"\\n            \"],[13],[1,\"\\n            \"],[10,1],[14,0,\"tOB--barGraph__value--end\"],[12],[1,\"\\n              \"],[1,[30,4,[\"max\"]]],[1,\"%\\n              \"],[1,[28,[35,4],[\"help\"],[[\"class\"],[\"o--icon--sm\"]]]],[1,\"\\n              \"],[8,[39,5],null,[[\"@event\"],[\"hover\"]],[[\"default\"],[[[[1,\"\\n                \"],[10,1],[12],[1,\"\\n                  \"],[1,[28,[35,3],[\"profile_categorization.reports.shared.high_end\"],null]],[1,\"\\n                \"],[13],[1,\"\\n              \"]],[]]]]],[1,\"\\n            \"],[13],[1,\"\\n\"]],[]]],[1,\"        \"],[13],[1,\"\\n\\n        \"],[10,0],[14,0,\"tOB--barGraph__markers\"],[12],[1,\"\\n          \"],[10,0],[14,0,\"tOB--barGraph__marker\"],[15,5,[29,[\"left:\",[30,0,[\"industryMarkerPostion\"]],\"%;\"]]],[12],[1,\"\\n            \"],[10,\"img\"],[14,0,\"o--media\"],[14,\"src\",\"assets/images/tOB--image__industry.png\"],[12],[13],[1,\"\\n            \"],[10,1],[14,0,\"tOB--barGraph__tooltip tOB--barGraph__tooltip--bottom\"],[12],[1,\"\\n              \"],[1,[28,[35,3],[[28,[37,2],[[30,3],\"industry_average\"],null]],null]],[1,\"\\n              (\"],[1,[30,5]],[1,\"%)\\n            \"],[13],[1,\"\\n          \"],[13],[1,\"\\n\\n          \"],[10,0],[15,0,[29,[\"tOB--barGraph__marker\\n              \",[52,[30,0,[\"isAboveAverage\"]],\"tOB--barGraph__marker--above\",\"tOB--barGraph__marker--below\"]]]],[15,5,[29,[\"left:\",[30,0,[\"profileMarkerPostion\"]],\"%;\"]]],[12],[1,\"\\n            \"],[10,\"img\"],[14,0,\"o--media\"],[15,\"src\",[30,6,[\"avatarUrl\"]]],[12],[13],[1,\"\\n            \"],[10,1],[14,0,\"tOB--barGraph__tooltip tOB--barGraph__tooltip--top\"],[12],[1,\"\\n              \"],[1,[28,[35,3],[\"profile_categorization.reports.shared.profile_engagement\"],[[\"engagement\",\"nickname\"],[[30,7],[30,6,[\"nickname\"]]]]]],[1,\"\\n            \"],[13],[1,\"\\n          \"],[13],[1,\"\\n        \"],[13],[1,\"\\n      \"],[13],[1,\"\\n\\n\"]],[]]],[1,\"\\n    \"],[10,\"h4\"],[14,0,\"u--text--md u--m__tb\"],[12],[1,\"\\n      \"],[1,[28,[35,3],[[28,[37,2],[[30,3],\"engagement_summary\"],null]],null]],[1,\"\\n    \"],[13],[1,\"\\n\\n    \"],[10,0],[14,0,\"u--m__tb\"],[12],[1,[30,0,[\"rewardText\"]]],[13],[1,\"\\n\\n    \"],[10,1],[14,0,\"u--text--bold\"],[12],[1,[28,[35,3],[[28,[37,2],[[30,3],\"tips\"],null]],null]],[13],[1,\"\\n\\n    \"],[1,[28,[35,8],[[28,[37,3],[[28,[37,2],[[30,3],[52,[30,0,[\"isAboveAverage\"]],\"success_links_html\",\"failure_links_html\"]],null]],null]],null]],[1,\"\\n\\n    \"],[10,2],[14,0,\"u--text--sm u--text--light u--m__b__0\"],[12],[1,[28,[35,3],[\"profile_categorization.reports.disclaimer\"],null]],[13],[1,\"\\n\\n\"]],[3]]],[13]],[\"@triggerSegmentEvent\",\"@sectionName\",\"prefix\",\"@limits\",\"@industryEngagement\",\"@socialProfile\",\"@profileEngagement\"],false,[\"did-insert\",\"let\",\"concat\",\"t\",\"svg-jar\",\"ember-tooltip\",\"if\",\"lt\",\"html-safe\"]]",
    "moduleName": "shared/components/shared/profile-categorization/rewards-steps/tab/engagement-distribution.hbs",
    "isStrictMode": false
  });
  let EngagementDistributionComponent = _exports.default = (_class = class EngagementDistributionComponent extends _component2.default {
    constructor() {
      super(...arguments);
      _initializerDefineProperty(this, "intl", _descriptor, this);
    }
    get industry() {
      return (0, _template.htmlSafe)(this.intl.t(`profile_categorization.industries.${this.args.socialProfile.industry}`));
    }
    get profileEngagementNumber() {
      return this._convertValueToNumber(this.args.profileEngagement, this.args.isLoading);
    }
    get industryEngagementNumber() {
      return this._convertValueToNumber(this.args.industryEngagement, this.args.isLoading);
    }
    get limitsNumber() {
      return {
        min: this._convertValueToNumber(this.args.limits.min),
        max: this._convertValueToNumber(this.args.limits.max)
      };
    }
    get isBelowMin() {
      if (!this.profileEngagementNumber || !this.limitsNumber.min) {
        return null;
      }
      return this.profileEngagementNumber < this.limitsNumber.min;
    }
    get isAboveMax() {
      if (!this.profileEngagementNumber || !this.limitsNumber.max) {
        return null;
      }
      return this.profileEngagementNumber > this.limitsNumber.max;
    }
    get topPercent() {
      return this.isAboveMax ? this.profileEngagementNumber : this.limitsNumber.max;
    }
    get topPercentRounded() {
      return (0, _numberHelpers.preciseRound)(this.topPercent, 1);
    }
    get isAboveAverage() {
      if (!this.profileEngagementNumber || !this.industryEngagementNumber) {
        return null;
      }
      return this.profileEngagementNumber > this.industryEngagementNumber;
    }
    get industryLimitsPositions() {
      const absoluteLeft = this.limitsNumber.min < 0 ? 0 : (0, _numberHelpers.preciseRound)((0, _numberHelpers.ratioToPercent)(this.limitsNumber.min / this.topPercent), 1);
      return {
        left: this.isBelowMin ? absoluteLeft : 0,
        right: (0, _numberHelpers.preciseRound)((0, _numberHelpers.ratioToPercent)(1 - this.limitsNumber.max / this.topPercent), 1)
      };
    }
    get industryMarkerPostion() {
      return (0, _numberHelpers.preciseRound)((0, _numberHelpers.ratioToPercent)(this.industryEngagementNumber / this.topPercent), 1);
    }
    get profileMarkerPostion() {
      return (0, _numberHelpers.preciseRound)((0, _numberHelpers.ratioToPercent)(this.profileEngagementNumber / this.topPercent), 1);
    }
    get changeFromAverage() {
      if (!this.profileEngagementNumber || !this.industryEngagementNumber) {
        return null;
      }
      const percent = this.profileEngagementNumber - this.industryEngagementNumber;
      return (0, _numberHelpers.preciseRound)(Math.abs(percent), 2);
    }
    get rewardText() {
      if (!(0, _utils.isPresent)(this.profileEngagementNumber) || !(0, _utils.isPresent)(this.industryEngagementNumber)) {
        return null;
      }
      const percent = this.profileEngagementNumber - this.industryEngagementNumber;
      const percentFromAverage = `${(0, _numberHelpers.preciseRound)(Math.abs(percent), 2)}%`;
      if (percent > 0) {
        return (0, _template.htmlSafe)(this.intl.t(`profile_categorization.reports.${this.args.sectionName}.engagement_distribution.success`, {
          percentFromAverage
        }));
      } else if (percent === 0) {
        return (0, _template.htmlSafe)(this.intl.t(`profile_categorization.reports.${this.args.sectionName}.engagement_distribution.equal`, {
          percentFromAverage
        }));
      }
      return (0, _template.htmlSafe)(this.intl.t(`profile_categorization.reports.${this.args.sectionName}.engagement_distribution.failure`, {
        percentFromAverage
      }));
    }
    _convertValueToNumber(value) {
      let isLoading = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
      if (!value || isLoading) {
        return null;
      }
      return Number(value);
    }
  }, (_descriptor = _applyDecoratedDescriptor(_class.prototype, "intl", [_service.inject], {
    configurable: true,
    enumerable: true,
    writable: true,
    initializer: null
  })), _class);
  (0, _component.setComponentTemplate)(__COLOCATED_TEMPLATE__, EngagementDistributionComponent);
});